<template>
    <modal
        name="email-confirmation-pass"
        height="auto"
        width="30%"
        :scrollable="true"
        :adaptive="true"
        class="email-confirmation-pass"
        @before-open="beforeOpen">
        <div class="icon-close-modal" @click="$modal.hide('email-confirmation-pass')">
            <button class="btn btn-orange">
                <i class="fas fa-times"></i>
            </button>
        </div>
        <div class="container-fluid thankyou-fancy" v-if="success && !error">
            <div class="content text-center p-5 thankyou-fancy--content">
                <i class="fas fa-check-circle thanks-check"></i><br/>
                <h1>¡Correo Enviado!</h1>
                <p>Te hemos enviado un correo para que puedas cambiar tu contraseña.</p>
            </div>
        </div>
        <ModalError v-if="!success && error">No existe un usuario con el correo electrónico proporcionado</ModalError>
    </modal>

</template>
<script>
    import ModalError from "@/components/ModalError";
    export default {
        name: "ModalForgotPass",
        components: {
            ModalError
        },
        data() {
            return {
                success: false,
                error: false
            }
        },
        methods:{
            beforeOpen(event) {
                this.success = event.params ? event.params.success : false;
                this.error = event.params ? event.params.error : false;
            }
        }
    }
</script>
<style lang="scss" scoped>
.icon-close-modal {
    position: absolute;
    top: -15px;
    right: -15px;
    z-index:1;

    button {
        border-radius: 50%;
        padding: 0;
        width: 50px;
        height: 50px;

        i {
            font-size: $medium-font-size;
        }
    }
}
.thankyou-fancy {
    margin-top: 2em;
    margin-bottom: 2em;
    position: relative;
    border-radius: 1em;

    .thankyou-fancy--content {
        .thanks-check {
            font-size: 80px;
            color: $primary-color;
            margin-bottom: 35px;
        }

        h1 {
            font-size: $large-font-size;
            font-family: $primary-font;
            color: $primary-color;
        }

        p {
            font-size: $small-font-size;
        }
    }
}

@media screen and ( max-width:768px) {
    .thankyou-fancy {

        .thankyou-fancy--content {
            padding: 60px 15px!important;

            p {
                font-size: $mobile-small-font-size;
            }
        }
    }
}
</style>